// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a65b2bf4","186":"c4afb4ea","225":"343b7317","344":"58beecfe","372":"2cae1fb3","738":"1d76a5a8","841":"81c19d38","856":"28922eb3"}[chunkId] + ".chunk.js";
};